import { render, staticRenderFns } from "./ExchangeRateSourceSelector.yaml?vue&type=template&id=0b6549ef&component"
import script from "./ExchangeRateSourceSelector.yaml?vue&type=script&lang=ts&component"
export * from "./ExchangeRateSourceSelector.yaml?vue&type=script&lang=ts&component"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports